// extracted by mini-css-extract-plugin
module.exports = {"dotloader":"LoaderDots_dotloader__9oDzZ","bouncedelay":"LoaderDots_bouncedelay__2HMjT","dotloader1":"LoaderDots_dotloader1__2FrjJ","dotloader2":"LoaderDots_dotloader2__6ieHh"};